<sm-title-bar [pageTitle]="interestType == '0' ? 'Home service Bookings & queries' : (interestType == '1' ? 'In-premise Bookings & queries' : (interestType == '2' ? 'Virtual service Bookings & queries' : 'All activity '))  " [backWithParams]="true" 
[headerCustomTemplate]="addButton">
<ng-template #addButton>
   <div class="booking_sectionkl" *ngIf="interestType == '4'">
      <div class="date-range-form">
          <div class="nw_all">
          <mat-form-field appearance="outline">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromDatePicker" [(ngModel)]="fromDate" readonly>
            <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>
       </div>
      
       <div class="nw_all">
          <mat-form-field appearance="outline">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toDatePicker" [(ngModel)]="toDate" readonly>
            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>
          </div>
          <div class="search_pag">
          <button mat-flat-button color="primary" type="submit" (click)="onSearch()">Search</button>
      </div>
    </div>
  </div>
   <!-- <div class="d-flex search-field" *ngIf="interestType != '4'">
      <div class="Create_header_btn">
        
         <button mat-flat-button color="primary" (click)="addNewInterest()">
            <mat-icon>add</mat-icon>
            Add new
         </button>
        
      </div>
       
        <div class="booking_sedr">
         <button mat-flat-button color="primary" (click)="refresh()">
           <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
       </button>
       </div>
   </div> -->
</ng-template>

</sm-title-bar>
<div class="chip_cont">
   <div class="booing_sectyy">
   <div class="row align-items-center">
      <div class="col-sm-12">
   <div class="booing_sectyy">   
      <mat-chip-list aria-label="Fish selection" class="mb-3" *ngIf="interestType != '4'">
         <mat-chip
         (click)="changeChip('0')"
         [ngClass]="{'Graceful-box-active': selectedValue == '0' && processType == 2}"
         style="height: auto">Today
         </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-3" *ngIf="interestType != '4'">
         <mat-chip
         (click)="changeChip('1')"
         [ngClass]="{'Graceful-box-active': selectedValue == '1' && processType == 2}"
         style="height: auto">Tomorrow 
         </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-1" *ngIf="interestType == '4'">
         <mat-chip
         (click)="changeChip('3')"
         [ngClass]="{'Graceful-box-active': selectedValue == '3' && processType == 3}"
        >Attendance
         </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-3" *ngIf="interestType == '4'">
         <mat-chip
         (click)="changeChip('2')"
         [ngClass]="{'Graceful-box-active': selectedValue == '2' && processType == 3}"
         style="height: auto">Session booking
         </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-3">
         <mat-chip
         (click)="changeInterestStatus('1')"
         [ngClass]="{'Graceful-box-active': interestStatus == '1' && processType == 1}"
         style="height: auto">Membership request 
         </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-3">
         <mat-chip
         (click)="changeInterestStatus('2')"
         [ngClass]="{'Graceful-box-active': interestStatus == '2' && processType == 1}"
         style="height: auto">Customer queries 
         </mat-chip>
      </mat-chip-list>

   </div>
</div>

   </div>
   </div>

   <div class="booking_sectionkl" *ngIf="interestType != '4'">
      <!-- <div class="Create_header_btn">
        <button mat-flat-button color="primary" (click)="createNewBooking()"> <mat-icon>add</mat-icon> Booking</button>
     </div>
    
     <div class="Create_header_btn">
      <button mat-flat-button color="primary" (click)="addNewInterest()"> <mat-icon>add</mat-icon> Query</button>
     </div> -->
      <!-- new button add -->

           <div class="Create_header_btn">
        <button
          mat-flat-button
          color="primary"
          [matMenuTriggerFor]="addMenu">
          <mat-icon>add</mat-icon>
          Add new
        </button>
        </div>
        <!-- Menu -->

        <mat-menu #addMenu="matMenu">
          <button mat-menu-item  (click)="createNewBooking()">
            <mat-icon>event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterest()">
            <mat-icon>card_membership</mat-icon>
            <span>New membership request</span>
          </button>
        </mat-menu>

      <!-- end new button -->
     <div class="booking_sedr">
      <button mat-flat-button color="primary" (click)="refresh()">
        <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
    </button>
    </div>
  
    </div>
   <div class="booking_sectionkl" *ngIf="interestType == '4'">
      <!-- <div class="Create_header_btn">
        <button *ngIf="isAccessForEmployeeInvoice" mat-flat-button color="primary" (click)="createNewBookingFromList()"> <mat-icon>add</mat-icon> Booking</button>
     </div>
    
     <div class="Create_header_btn">
      <button *ngIf="isAccessForEmployeeInvoice" mat-flat-button color="primary" (click)="addNewInterestFromList()"> <mat-icon>add</mat-icon> Query</button>
     </div> -->
     <!-- <div class="booking_sedr">
      <button mat-flat-button color="primary" (click)="refresh()">
        <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
    </button>
    </div> -->
      <div class="Create_header_btn">
        <button
          mat-flat-button
          color="primary"
          [matMenuTriggerFor]="addMenu">
          <mat-icon>add</mat-icon>
          Add new
        </button>
        </div>
        <!-- Menu -->

        <mat-menu #addMenu="matMenu">
          <button mat-menu-item  (click)="createNewBookingFromList()">
            <mat-icon>event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterestFromList()">
            <mat-icon>card_membership</mat-icon>
            <span>New membership request</span>
          </button>
        </mat-menu>
  
    </div>

</div>
  <!-- <div class="booking_sedr">
         <button mat-flat-button color="primary">
            <mat-icon class="material-icons-round" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
         </button>
      </div> -->
<!-- <div *ngIf="loader" class="loader">
   <mat-spinner></mat-spinner>
</div> -->

<mat-form-field appearance="outline" *ngIf="!loader && interestType == '4' && processType == 1 && interestStatus == '1'">
   <mat-label>Search</mat-label>
   <input matInput placeholder="Search joining query list" [(ngModel)]="searchString" (keyup)="searchNameData()">
   <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
<!-- <mat-card style="padding-bottom: 0px;" *ngIf="!loader && interestType == '4'">

</mat-card> -->


<!-- MEMBERSHIP QUERIES START -->
<mat-card style="margin-bottom: 10px;" *ngIf="!loader && interestData.length > 0  && processType == 1  && interestStatus == '1'">

   <div class="rounded-3 bg-light" >
      <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumns"
      [dataSource]="interestData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [rowClickHandler]="rowClickHandler"
      >
      <ng-template #costTemplate let-rowVal="row" let-colVal="col">
        adas
      </ng-template>
      </sm-data-table-for-appointments>
   </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
   <div>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
      </button>
   <!-- <button mat-menu-item (click)="addReply(rowvalue)" *ngIf="rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">reply</mat-icon>
   <span>Reply</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,1)" *ngIf="rowvalue.enrollment_request_status != 1 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">grade</mat-icon>
   <span>Mark as new</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,2)" *ngIf="rowvalue.enrollment_request_status != 2 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
   <span>Mark as in-progress</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,3)" *ngIf="rowvalue.enrollment_request_status != 3 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">task_alt</mat-icon>
   <span>Mark as enrolled</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,4)" *ngIf="rowvalue.enrollment_request_status != 4 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">cancel</mat-icon>
   <span>Mark as cancelled</span>
   </button>
   <button mat-menu-item (click)="addAsMember(rowvalue)" *ngIf="rowvalue.enrollment_request_status == 3 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">person_add</mat-icon>
   <span> Add in enrolled members</span>
   </button>
   <button mat-menu-item (click)="deleteQuery(rowvalue)" *ngIf="(!rowvalue.customer_account_hash ||  rowvalue.customer_account_hash == 'null') && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">delete</mat-icon>
   <span> Delete query</span>
   </button> -->
</div>
 

</ng-template>
<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="!loader && interestData.length == 0  && processType == 1  && interestStatus == '1'">
   <div class="row">
      <div class="col-sm-4" *ngIf="interestStatus == '1'">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
<!-- 
      <div class="col-sm-4" *ngIf="interestStatus == '2'">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/in-progress.png">
                  </div>
                  <mat-card-title>No in-progress query.</mat-card-title>
                  <mat-card-content>People's queries and joining interests which are in-progress, will appear here. You can see details, track them and change the status from here.
                  </mat-card-content>
                 
               </div>
            </mat-card>
         </div>
      </div>
      <div class="col-sm-4" *ngIf="interestStatus == '3'">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/queries-marked.jpg ">
                  </div>
                  <mat-card-title>No queries marked as enrolled.</mat-card-title>
                  <mat-card-content>People's queries and joining interests who already enrolled, will appear here. You can see details, track them and change the status from here.
                  </mat-card-content>
                 
               </div>
            </mat-card>
         </div>
      </div>
      <div class="col-sm-4" *ngIf="interestStatus == '4'">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/cancelled-pp.jpg">
                  </div>
                  <mat-card-title>No queries marked as cancelled.</mat-card-title>
                  <mat-card-content>People's queries and joining interests which made cancelled, will appear here. You can see details, track them and change the status from here.
                  </mat-card-content>
               </div>
            </mat-card>
         </div>
      </div> -->
      <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card>
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div>
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties in adding a new query or issue with managing them, contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->


<!-- MEMBERSHIP QUERIES END -->



<!-- -----------------TODAY TOMORROW START------------------------- -->


<mat-card *ngIf=" !loader && bookingsData.length > 0 && processType == 2">
   <mat-card-header class="justify-content-between align-items-center mb-3">
   </mat-card-header>
   <div class="rounded-3 bg-light">
     <sm-data-table-for-appointments
       [columnHeaders]="tableDisplayColumnsForBookings"
       [dataSource]="bookingsData"
       [showPagination]="true"
       [itemsPerPage]="25"
       [showMenuButton]="true"
       [menuDropdownTemplate]="menuTemplate2"
      [rowClickHandler]="rowClickHandlerForTT"
     >
 
     <ng-template #costTemplate let-rowVal="row" let-colVal="col">
       {{rowVal[colVal.columnProperty] | currency: 'INR'}}
     </ng-template>
     </sm-data-table-for-appointments>
   </div>
 </mat-card>
 
 <ng-template #menuTemplate2 let-rowvalue>
   <div *ngIf="rowvalue.data_type == 1">
      <button mat-menu-item  (click)="bookingDetails(rowvalue)">
        <mat-icon class="material-icons-outlined">info</mat-icon>
        <span>{{ 'business_bookings.opt_booking_details' | translate }}</span>
      </button>
     <!-- <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2) && (rowvalue.customerInfo.hash_id && rowvalue.customerInfo.hash_id != 'null') && (isOwner || interestType != '4'))" (click)="confirmBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">check_circle</mat-icon>
       <span>{{ 'business_bookings.opt_confirm_booking' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5) && (isOwner || interestType != '4') && selectedValue == '0' && processType == 2" (click)="startProcess(rowvalue)">
       <mat-icon class="material-icons-outlined">timer</mat-icon>
       <span>{{ 'business_bookings.opt_start_process' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5) && isOwner && selectedValue == '0' && processType == 2" (click)="assignJob(rowvalue)">
       <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
       <span>{{ 'business_bookings.opt_assign_job' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 5)  && selectedValue == '0' && processType == 2 && (isOwner || interestType != '4')" (click)="done(rowvalue)">
       <mat-icon class="material-icons-outlined">task_alt</mat-icon>
       <span>{{ 'business_bookings.opt_done' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4) && isOwner && selectedValue == '0' && processType == 2" (click)="customiseBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">tune</mat-icon>
       <span>Edit data</span>
     </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus != 4 && rowvalue.bookingStatus != 6 && rowvalue.bookingStatus != 8) && bookingType == '2'" (click)="addEditMeetingData(rowvalue)">
      <mat-icon class="material-icons-outlined">video_chat</mat-icon>
      <span>Meeting info</span>
    </button>
     <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4) && isOwner && selectedValue == '0' && processType == 2" (click)="reset(rowvalue)">
       <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
       <span>{{ 'business_bookings.opt_reset_to_new' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="rowvalue.bookingStatus == 4 && selectedValue == '0' && processType == 2 && (isOwner || interestType != '4')" (click)="openInvoice(rowvalue)">
       <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
       <span>{{ 'business_bookings.opt_invoice' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 5) && isOwner)" (click)="cancelBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">cancel</mat-icon>
       <span>{{ 'business_bookings.opt_cancel_booking' | translate }}</span>
     </button>
     <button mat-menu-item *ngIf="(!rowvalue.customerInfo.hash_id || rowvalue.customerInfo.hash_id == 'null') && isOwner && selectedValue == '0' && processType == 2" (click)="deleteBooking(rowvalue)">
       <mat-icon class="material-icons-outlined">delete</mat-icon>
       <span>Delete booking</span>
     </button> -->
   </div>
     <div *ngIf="rowvalue.data_type == 2">
    
      <button mat-menu-item (click)="bookingDetails(rowvalue)">
         <mat-icon class="material-icons-outlined">info</mat-icon>
         <span>View details</span>
         </button>
      <!-- <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && interestType == '4')" (click)="changeAttendanceStatus(1,rowvalue)" *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == null || rowvalue.bookingStatus == 'null') && (rowvalue.session_status != 3)" > 
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>Mark as present</span>
      </button>
      <button mat-menu-item (click)="operationForMember(rowvalue,3)" *ngIf="rowvalue.bookingStatus == 1 && rowvalue.session_status == 2 && rowvalue.session_status != 3">
      <mat-icon class="material-icons-outlined">task_alt</mat-icon>
      <span>Job done</span>
      </button>
      <button mat-menu-item (click)="assignJobForMember(rowvalue)" *ngIf="rowvalue.bookingStatus == 1  && rowvalue.session_status != 3 && isOwner">
      <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
      <span>Assign job</span>
      </button>
      <button mat-menu-item (click)="operationForMember(rowvalue,2)" *ngIf="rowvalue.bookingStatus == 1 && rowvalue.session_status != 3 && rowvalue.session_status != 2">
      <mat-icon class="material-icons-outlined">timer</mat-icon>
      <span>Start job</span>
      </button>
      <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && interestType == '4')" (click)="changeAttendanceStatus(0,rowvalue)" *ngIf="(rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == null || rowvalue.bookingStatus == 'null') && (rowvalue.session_status != 3)">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>Mark as absent</span>
      </button>
      <button mat-menu-item [disabled]="(processType == 2 && selectedValue == '1') || (!isOwner && rowvalue.session_status == 3) || (!isOwner && interestType == '4')" *ngIf="rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1" (click)="deleteAttendance(rowvalue)" [disabled]="">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete attendance</span>
      </button>
      -->

 </div>
   </ng-template> 
 
 
 
   <!-- placeholder html start -->
   <div class="placeholder_started" *ngIf="!loader && bookingsData.length == 0  && processType == 2">
         <div class="row">
           <div class="col-sm-4" *ngIf="selectedValue == '0'">
             <div class="dashboard_new">
               <mat-card>
                   <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/bookings-pp.png">
                  </div>
                  <mat-card-title>No bookings for today.</mat-card-title>
                  <mat-card-content>There's no booking done by any customer or from the house for today. Though you can create one from here.
                 </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary" (click)="createNewBooking()">
                       <mat-icon>add</mat-icon>
                       New booking
                     </button>
                  </div>
                  </div>
               </mat-card>
            </div>
           </div>
           <div class="col-sm-4" *ngIf="selectedValue == '1'">
             <div class="dashboard_new">
               <mat-card>
                   <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/bookings-pp.png">
                  </div>
                  <mat-card-title>No bookings for tomorrow.</mat-card-title>
                  <mat-card-content>There's no booking done by any customer or from the house for tomorrow. Though you can create one from here.
                 </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary" (click)="createNewBooking()">
                        <mat-icon>add</mat-icon>
                        New booking
                     </button>
                  </div>
                  </div>
               </mat-card>
            </div>
           </div>
           <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new booking against a business. You can check this video as well. 

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
           <div class="col-sm-4">
             <div class="dashboard_new">
               <mat-card>
                   <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties in creating a new booking or in issue in getting booking list data, contact our support team. 
                 </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
                  </div>
               </mat-card>
            </div>
           </div>
         </div>
   </div> 
   <!-- placeholder html end -->

<!-- -----------------TODAY TOMORROW END------------------------- -->

   <!-- --------SESSION BOOKINGS START -------------->
    
   <div class="schedule-container" *ngIf="!loader && messageList.length > 0 && processType == 3 && selectedValue == '2'">
      <div class="table-container">
          <mat-table [dataSource]="messageList" class="mat-elevation-z1">
            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.booking_date ? (element.booking_date | date) : '---'}} </mat-cell>
            </ng-container>
         
            <ng-container matColumnDef="customerName">
              <mat-header-cell *matHeaderCellDef> Customer Name </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.customerName}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="noOfServices">
              <mat-header-cell *matHeaderCellDef> No. Of Services </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.servicesCount}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="cost">
              <mat-header-cell *matHeaderCellDef> Cost </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.price}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="bookingStatus">
              <mat-header-cell *matHeaderCellDef> Booking Status </mat-header-cell>
              <mat-cell *matCellDef="let element" [class.new-booking]="element.bookingStatus == 0 ||element.bookingStatus == 1 || element.bookingStatus == 2" [class.under-process]="element.bookingStatus == 3 || element.bookingStatus == 7 || element.bookingStatus == 9" [class.completed]="element.bookingStatus == 4" [class.cancelled]="element.bookingStatus == 6 || element.bookingStatus == 8" [class.confirmed]="element.bookingStatus == 5"> {{element.bookingStat}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="paymentStatus">
              <mat-header-cell *matHeaderCellDef> Payment Status </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.paymentStat}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="startTime">
              <mat-header-cell *matHeaderCellDef> Start Time </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.bookingStartTime}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endTime">
              <mat-header-cell *matHeaderCellDef> End Time </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.bookingEndTime}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="assignedTo">
              <mat-header-cell *matHeaderCellDef> Assigned To </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.employeeName}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="bookingType">
              <mat-header-cell *matHeaderCellDef> Booking Type </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.booking_type}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element" class="menu-cell">
                   <div class="icon-wrapper" >
                    <button mat-icon-button class="custom-icon-button"  >
                        <mat-icon>arrow_forward</mat-icon>
                      </button>
                </div>
              
                <mat-menu #menu="matMenu">
                  <div *ngIf="element.data_type == 1">
                     <button mat-menu-item (click)="bookingDetailsForHistory(element)">
                         <mat-icon class="material-icons-outlined">info</mat-icon>
                         <span>Booking details</span>
                     </button>
                  <!-- <button mat-menu-item (click)="confirmBookingForHistory(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2) && (element.customerInfo.hash_id && element.customerInfo.hash_id != 'null')) && (element.toshowOptions == 1) && (isOwner || interestType != '4'))">
                      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                      <span>Confirm booking</span>
                  </button>
                  <button mat-menu-item *ngIf="element.bookingStatus == 4 && (isOwner || interestType != '4')" (click)="openInvoiceForHistory(element)">
                      <mat-icon class="material-icons-outlined">badge</mat-icon>
                      <span>Invoice</span>
                  </button>
                  <button mat-menu-item (click)="cancelBookingForHistory(element)" *ngIf="(((element.bookingStatus == 0 || element.bookingStatus == 1 || element.bookingStatus == 2 || element.bookingStatus == 5)) && (element.toshowOptions == 1) && (isOwner))">
                      <mat-icon class="material-icons-outlined">cancel</mat-icon>
                      <span>Cancel booking</span>
                  </button>
                  <button mat-menu-item *ngIf="(!element.customerInfo.hash_id || element.customerInfo.hash_id == 'null') && isOwner" (click)="deleteBookingForHistory(element)">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete booking</span>
                  </button> -->
               </div>

                  <div *ngIf="element.data_type == 2">
    
                     <button mat-menu-item   (click)="changeAttendanceStatus(1,element)" *ngIf="element.bookingStatus == 0 || element.bookingStatus == null || element.bookingStatus == 'null'" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                     <span>Mark as present</span>
                     </button>
                     <!-- <button mat-menu-item (click)="operationForMember(element,3)">
                     <mat-icon class="material-icons-outlined">task_alt</mat-icon>
                     <span>Job done</span>
                     </button>
                     <button mat-menu-item  (click)="assignJobForMember(element)">
                     <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
                     <span>Assign job</span>
                     </button>
                     <button mat-menu-item  (click)="operationForMember(element,2)">
                     <mat-icon class="material-icons-outlined">timer</mat-icon>
                     <span>Start job</span>
                     </button> -->
                     <button mat-menu-item  (click)="changeAttendanceStatus(0,element)" *ngIf="element.bookingStatus == 1 || element.bookingStatus == null || element.bookingStatus == 'null'" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">cancel</mat-icon>
                     <span>mark as absent</span>
                     </button>
                     <button mat-menu-item  *ngIf="element.bookingStatus == 0 || element.bookingStatus == 1" (click)="deleteAttendance(element)" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">delete</mat-icon>
                     <span>Delete attendance</span>
                     </button>
                    
              
                </div>

              </mat-menu>



              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="bookingDetailsForHistory(row)"></mat-row>
          </mat-table>
        </div>
    </div>

  
  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && messageList.length == 0 && processType == 3 && selectedValue == '2'">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/bookings-pp.png">
                 </div>
                 <mat-card-title>No booking to show.</mat-card-title>
                 <mat-card-content>All the bookings will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new booking against a business. You can check this video as well. 

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in getting the list of bookings or issue with managing them, contact our support team. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 

  <!-- placeholder html end -->

     <!-- --------SESSION BOOKINGS END -------------->


   <!-- --------ATTENDANCE START -------------->
    
   <div class="schedule-container" *ngIf="!loader && attendanceList.length > 0 && processType == 3 && selectedValue == '3'">
      <div class="table-container">
          <mat-table [dataSource]="attendanceList" class="mat-elevation-z1">
            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.booking_date ? (element.booking_date | date) : '---'}} </mat-cell>
            </ng-container>
         
            <ng-container matColumnDef="customerName">
              <mat-header-cell *matHeaderCellDef> Customer Name </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.customerName}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="noOfServices">
              <mat-header-cell *matHeaderCellDef> No. Of Services </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.servicesCount}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="cost">
              <mat-header-cell *matHeaderCellDef> Cost </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.price}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="bookingStatus">
              <mat-header-cell *matHeaderCellDef> Booking Status </mat-header-cell>
              <mat-cell *matCellDef="let element" [class.cancelled]="(element.bookingStatus == 0 )&& element.data_type == 2"
              [class.new-booking]="(element.bookingStatus == 1 && !element.session_status ) && element.data_type == 2"
              [class.under-process]="(element.bookingStatus == 1 && (element.session_status ==  2 || element.session_status ==  1)) && element.data_type == 2"
              [class.completed]="(element.bookingStatus == 1 && element.session_status ==  3) && element.data_type == 2"> {{element.bookingStat}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="paymentStatus">
              <mat-header-cell *matHeaderCellDef> Payment Status </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.paymentStat}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="startTime">
              <mat-header-cell *matHeaderCellDef> Start Time </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.bookingStartTime}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endTime">
              <mat-header-cell *matHeaderCellDef> End Time </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.bookingEndTime}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="assignedTo">
              <mat-header-cell *matHeaderCellDef> Assigned To </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.employeeName}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="bookingType">
              <mat-header-cell *matHeaderCellDef> Booking Type </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.booking_type}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
              <mat-cell *matCellDef="let element">
                  <button mat-icon-button [matMenuTriggerFor]="menu" class="custom-icon-button">
                      <mat-icon>more_vert</mat-icon>
                    </button>
              
                <mat-menu #menu="matMenu">
                
                  
                  <div *ngIf="element.data_type == 2">
    
                     <button mat-menu-item   (click)="changeAttendanceStatus(1,element)" *ngIf="element.bookingStatus == 0 || element.bookingStatus == null || element.bookingStatus == 'null'" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                     <span>Mark as present</span>
                     </button>
                     <button mat-menu-item  (click)="changeAttendanceStatus(0,element)" *ngIf="element.bookingStatus == 1 || element.bookingStatus == null || element.bookingStatus == 'null'" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">cancel</mat-icon>
                     <span>mark as absent</span>
                     </button>
                     <button mat-menu-item  *ngIf="element.bookingStatus == 0 || element.bookingStatus == 1" (click)="deleteAttendance(element)" [disabled]="!isOwner && interestType == '4'">
                     <mat-icon class="material-icons-outlined">delete</mat-icon>
                     <span>Delete attendance</span>
                     </button>
                    
              
                </div>

              </mat-menu>



              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
        </div>
    </div>

  
 <!-- placeholder html start -->
<div class="placeholder_started" *ngIf="!loader && attendanceList.length == 0 && processType == 3 && selectedValue == '3'">
   <div class="row">
     <div class="col-sm-4">
       <div class="dashboard_new">
         <mat-card appearance="outlined">
             <div class="upload_sectio">
            <div class="icm_img">
               <img src="./assets/images/bookings-pp.png">
            </div>
            <mat-card-title>No attendance list to show here.</mat-card-title>
            <mat-card-content>All the attendances will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
           </mat-card-content>
            <!-- <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div> -->
            </div>
         </mat-card>
      </div>
     </div>
     <div class="col-sm-4">
       <div class="dashboard_new">
         <mat-card appearance="outlined">
             <div class="upload_sectio">
            <div class="icm_img">
               <img src="/assets/images/new-booking.png">
            </div>
            <mat-card-title>How attendance work?</mat-card-title>
            <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on marking present and absent against members. You can check this video as well. 

            </mat-card-content>
           <div class="watch_vc_btn">
             <button mat-stroked-button color="primary" (click)="openVideoForAttendance()">
                <mat-icon>play_arrow</mat-icon>
                Watch video
             </button>
          </div>
            </div>
         </mat-card>
      </div>
     </div>
     <div class="col-sm-4">
       <div class="dashboard_new">
         <mat-card appearance="outlined">
             <div class="upload_sectio">
            <div class="icm_img">
               <img src="./assets/images/helpsupport.png">
            </div>
            <mat-card-title>Facing any issue?</mat-card-title>
            <mat-card-content>For any difficulties in getting the list of bookings or issue with managing them, contact our support team. 
           </mat-card-content>
            <div class="watch_vc_btn">
               <button mat-stroked-button color="primary"  (click)="opencontact()">
                  <mat-icon>support_agent</mat-icon>
                  Contact support 
               </button>
            </div>
            </div>
         </mat-card>
      </div>
     </div>
   </div>
</div> 

<!-- placeholder html end -->   

     <!-- --------ATTENDANCE END -------------->


  <!--  QUERIES START -->
<mat-card style="margin-bottom: 10px;" *ngIf="!loader && queryData.length > 0  && processType == 1  && interestStatus == '2'">

   <div class="rounded-3 bg-light" >
      <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumnsforserviceQuery"
      [dataSource]="queryData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [rowClickHandler]="rowClickHandlerforservicequery"
      >
      <ng-template #costTemplate let-rowVal="row" let-colVal="col">
        adas
      </ng-template>
      </sm-data-table-for-appointments>
   </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
   <div>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
      </button>
  
</div>
 

</ng-template>
<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="!loader && queryData.length == 0  && processType == 1  && interestStatus == '2'">
   <div class="row">
      <div class="col-sm-4" >
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No service queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
               </div>
            </mat-card>
         </div>
      </div>

      <!-- <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card>
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div> -->
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->


<!--  QUERIES END -->